<button type="button" [disabled]="(isDisabled | async) || (isLoading | async)" class="{{bgColor()}} {{textColor()}} hover:{{textHoverColor()}} {{ fontSize() }}
    whitespace-nowrap min-h-[40px] rounded-lg border-0 focus:outline-none py-2 {{addClasses()}}"
    (click)="handleClick()">
    @if (prefixIcon()) {
    <i class="{{ prefixIcon() }} mr-1"></i>
    }
    {{ label() }}
</button>